import { IconEyeOff } from '@rossum/ui/icons/tabler';
import { Box, Stack, SvgIcon, Tooltip } from '@rossum/ui/material';
import { CSSProperties } from 'react';
import { useIntl } from 'react-intl';
import FooterCell from '../../../../../components/footerCell';
import { OriginalAnyDatapointSchema } from '../../../../../types/schema';
import { isFieldRequired } from '../helpers';
import styles from './style.module.sass';

type HeaderInJsonSchemaEditorProps = {
  columns: Array<OriginalAnyDatapointSchema>;
  style: CSSProperties;
};

export const HeaderInJsonSchemaEditor = ({
  columns,
  style,
}: HeaderInJsonSchemaEditorProps) => {
  const intl = useIntl();
  return (
    <Box
      style={style}
      className={styles.HeaderRow}
      sx={{
        boxShadow: t => t.shadows[3],
        borderTop: t => `1px solid ${t.palette.divider}`,
      }}
    >
      <div className={styles.HeaderWrapper} style={style}>
        {columns.map(
          ({ hidden, constraints, width, type = '', label, stretch, id }) => (
            <FooterCell
              key={id}
              width={width}
              stretch={!!stretch}
              label={label}
              type={type}
              uiFieldType={null}
            >
              {type === 'button' || (
                <Stack
                  className={styles.HeaderItem}
                  spacing={1}
                  direction={type === 'number' ? 'row-reverse' : 'row'}
                >
                  <div>{label}</div>
                  {isFieldRequired(constraints, type) && (
                    <Tooltip
                      title={intl.formatMessage({
                        id: 'containers.settings.queues.schema.sidebar.required',
                      })}
                    >
                      <span className={styles.Requirer}>&nbsp;*</span>
                    </Tooltip>
                  )}
                  {hidden && (
                    <SvgIcon fontSize="small">
                      <IconEyeOff />
                    </SvgIcon>
                  )}
                </Stack>
              )}
            </FooterCell>
          )
        )}
        <div className={styles.CollapseButtonPlaceholder} />
      </div>
    </Box>
  );
};
